import { useContext } from 'react'
import { AuthContext } from '../contexts/auth.context'
import { hasPermission } from '../utils/functions'

export const usePermission = (action?: string, resource_type?: string) => {
  const { user } = useContext(AuthContext)

  if (!action || !resource_type) {
    return true
  }

  if (!user) {
    return null
  }

  return hasPermission(action, resource_type, user.roles)
}
